import React, { FunctionComponent, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Config } from '~admin/config';
import { Links } from '~admin/route';
import { Box } from '~common/components/box.component';
import { Span } from '~common/components/span.component';
import { Overlay, OverlayProps } from '~web/view/components/layout/overlay.component';
import { ExternalLink } from '~web/view/components/ui/external-link.component';
import { IconProps } from '~web/view/components/ui/icon.component';
import { EditIcon } from '~web/view/components/ui/icon/edit.icon';

interface ActionButtonProps {
  label: string;
  icon?: React.ReactElement<IconProps>;
  onClick?: MouseEventHandler<HTMLElement>;
}

interface ManageEventOverlayProps extends OverlayProps {
  eventId: string;
  vanityName: string;
}

const ActionButton: FunctionComponent<ActionButtonProps> = ({ label, icon, onClick }) => (
  <Container onClick={onClick}>
    {icon && <IconBox>{icon}</IconBox>}
    <ActionText>{label}</ActionText>
  </Container>
);

export const ManageEventOverlay: FunctionComponent<ManageEventOverlayProps> = ({
  eventId,
  vanityName,
  onCancel,
  ...rest
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <StyledOverlay onCancel={onCancel} noCloseButton {...rest}>
      <ExternalLink
        href={Config.appUrl + Links.consumer.eventLanding({ urlParams: { eventId, vanityName } })}
      >
        <ActionButton label={t('viewEvents.manageEventOverlay.view')} />
      </ExternalLink>
      <ActionButton
        label={t('viewEvents.manageEventOverlay.edit')}
        icon={<EditIcon width={16} height={18} />}
        onClick={(): void => {
          history.push(Links.tool.editEvent({ eventId }));
        }}
      />
    </StyledOverlay>
  );
};

const StyledOverlay = styled(Overlay)`
  .overlay-content > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

const Container = styled(Box)`
  height: 80px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;

  &:hover {
    opacity: 0.88;
  }
`;

const ActionText = styled(Span)`
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${(props): string => props.theme.colors.white};
`;

const IconBox = styled(Box)`
  margin-right: 8px;
`;



// WEBPACK FOOTER //
// ./view/components/view-events/manage-event-overlay.component.tsx